<template>
  <div class="navi_bar">
    <div class="nav-container">
      <div class="logo">
        <el-image :src=logo fit="fill" class="logo"></el-image>
      </div>
      <div class="nav-menu">
        <nav><ul >
          <li v-for="(item, index) in nav_list" :key=index>
            <RouterLink :to=item.path>{{ $t(item.text) }}</RouterLink>
          </li>
        </ul></nav>
      </div>
      <div class="change-lang">
    <el-button @click="toggleLanguage">
      {{ $t("message.changeLanguage") }}
    </el-button>
      </div>
    </div>
</div>
</template>

<script>
import { RouterLink } from 'vue-router'
import logo from '@/assets/Loong/logo.jpg'
export default {
  name: 'NavBar',
  data () {
    return {
      logo: logo,
      menuProps: {
        router: true
      },
      nav_list: [
        { text: 'message.nav_list.Home.text', path: '/loong/home' },
        { text: 'message.nav_list.Demo.text', path: '/loong/demo' },
        // {text: '数据集和开源代码', path: '/dataset'},
        { text: 'message.nav_list.Publications.text', path: '/loong/publications' },
        { text: 'message.nav_list.News.text', path: '/loong/news' },
        // {text: '活动', path: '/activity'},
        { text: 'message.nav_list.Team.text', path: '/loong/group' }
        // {text: '合作单位', path: '/coauthor'}
      ]
    }
  },
  components: { RouterLink },
  methods: {
    toggleLanguage () {
      // 切换语言逻辑
      const newLang = this.$i18n.locale === 'zh' ? 'en' : 'zh'
      this.$i18n.locale = newLang // 设置新语言
      localStorage.setItem('language', newLang) // 保存到 localStorage
    }
  }
}
</script>

<style scoped>
    .navi_bar {
      position: relative;
      top: 0;
      left: 0;
      background-color: #fff;
      z-index: 1000;
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
      width: 100%;
      min-width: 1600px;
      border-bottom: 1px solid #eaeaea;
    }

    .nav-container {
      width: 100%;
      margin: 0 auto;
      padding: 1rem 2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      max-width: 1400px;
    }

    .logo {
      width: 200px;
      flex-shrink: 0;
    }

    .nav-menu {
      position: static;
      flex-grow: 1;
      display: flex;
      justify-content: center;
      margin: 0 2rem;
    }

    .nav-menu ul {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0;
      gap: 60px;
    }

    .nav-menu a {
      text-decoration: none;
      color: #333;
      font-weight: 500;
      font-size: 1.1rem;
      white-space: nowrap;
      padding: 0.5rem 0;
    }

    .nav-menu a:hover {
      color: #0066cc;
    }

    .change-lang {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      flex-shrink: 0;
      color: #666;
      font-size: 0.9rem;
    }

    @media (max-width: 768px) {
      .nav-container {
        padding: 0.8rem 1.5rem;
        flex-direction: row; /* 保持横向排列 */
      }

      .logo {
        width: 120px;
      }

      .nav-menu {
        margin: 0 1.5rem;
        justify-content: center;
        display: flex;
      }

      .nav-menu ul {
        gap: 25px;
        display: flex;
        flex-direction: row; /* 保持横向排列 */
      }

      .nav-menu a {
        font-size: 0.9rem;
        padding: 0.3rem 0;
      }
    }

    @media (max-width: 480px) {
      .navi_bar {
        width: 1600px;
      }
      .nav-container {
        padding: 0.7rem 1rem;
      }

      .logo {
        width: 100px;
      }

      .nav-menu {
        width: 70%;
        margin: 0 1rem;
      }

      .nav-menu ul {
        gap: 5rem;
      }

      .nav-menu a {
        font-size: 1.5rem;
      }

      .change-lang {
        font-size: 0.8rem;
      }
    }
</style>